<template>
    <v-container>
        <v-row>
            <v-col>
                <h1>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn icon
                                   @click="$router.push({name: 'character', params: {characterId: character.id}})"
                                   v-on="on"
                            >
                                <v-icon x-large>mdi-chevron-left</v-icon>
                            </v-btn>
                        </template>
                        <span>Go Back</span>
                    </v-tooltip>
                    Shop
                </h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="6" md="4" xl="3">
                <v-card class="mt-3">
                    <v-card-text>
                        <div @click="filterVisible = !filterVisible"
                             style="cursor: pointer;"
                             class="headline">Filter
                        </div>

                        <v-row v-if="filterVisible">
                            <v-col cols="12">
                                <v-checkbox v-model="filterForm.slots.head"
                                            label="Head Slot"
                                            hide-details
                                            @change="indexItems"/>
                                <v-checkbox v-model="filterForm.slots.body"
                                            label="Body Slot"
                                            hide-details
                                            @change="indexItems"/>
                                <v-checkbox v-model="filterForm.slots.legs"
                                            label="Legs Slot"
                                            hide-details
                                            @change="indexItems"/>
                                <v-checkbox v-model="filterForm.slots.oneHand"
                                            label="One-Hand Slot"
                                            hide-details
                                            @change="indexItems"/>
                                <v-checkbox v-model="filterForm.slots.twoHand"
                                            label="Two-Hand Slot"
                                            hide-details
                                            @change="indexItems"/>
                                <v-checkbox v-model="filterForm.slots.smallItem"
                                            label="Small Item Slot"
                                            hide-details
                                            @change="indexItems"/>

                                <v-checkbox v-model="filterForm.affordable"
                                            label="Affordable"
                                            hide-details
                                            @change="indexItems"
                                />
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="8" xl="9">

                <v-row>
                    <v-col cols="12" lg="4" xl="3" v-for="(item, itemIndex) of items" :key="itemIndex">

                        <v-card>
                            <v-card-title>#{{ item.number }} - {{ item.title }}</v-card-title>
                            <v-card-text>
                                <div>{{ item.description }}</div>
                                <div>Cost: {{ item.cost }}</div>
                                <div>Slot: {{ item.slot }}</div>
                                <div>Upon Usage: {{ item.discard_effect }}</div>
                                <div>Items In Shop: {{ item.amount }}</div>
                            </v-card-text>

                            <v-divider/>

                            <v-card-actions>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon
                                               color="primary"
                                               :disabled="item.cost > character.gold"
                                               @click="buyItem(item)"
                                               v-on="on"
                                        >
                                            <v-icon>mdi-cart-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Buy Item</span>
                                </v-tooltip>
                            </v-card-actions>
                        </v-card>

                    </v-col>
                </v-row>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import ItemService from "../services/ItemService";
  import CharacterService from "../services/CharacterService";

  export default {
    data: () => ({
      items: [],
      filterVisible: true,
      character: null,
      filterForm: {
        slots: {
          head: false,
          body: false,
          legs: false,
          oneHand: false,
          twoHand: false,
          smallItem: false
        },
        affordable: false
      }
    }),

    created() {
      this.viewCharacter();
      this.indexItems();
    },

    methods: {
      indexItems() {
        let filter = {
          affordable: this.filterForm.affordable,
          slots: this.getSlots()
        };

        ItemService.indexByCharacter(this.$route.params.characterId, filter)
          .then(response => {
            this.items = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },

      getSlots() {
        let slotString;

        slotString = this.getSlotCharacter(this.filterForm.slots.head);
        slotString += this.getSlotCharacter(this.filterForm.slots.body);
        slotString += this.getSlotCharacter(this.filterForm.slots.legs);
        slotString += this.getSlotCharacter(this.filterForm.slots.oneHand);
        slotString += this.getSlotCharacter(this.filterForm.slots.twoHand);
        slotString += this.getSlotCharacter(this.filterForm.slots.smallItem);

        return slotString;
      },

      getSlotCharacter(boolValue) {
        return (boolValue) ? '1' : '0';
      },

      viewCharacter() {
        CharacterService.view(this.$route.params.characterId)
          .then(response => {
            this.character = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },

      buyItem(item) {
        if (confirm(`Are you sure you want to buy item #${item.number} to the cost of ${item.cost} gold?`)) {
          CharacterService.buyItem(this.character.id, item.id)
            .then(() => {
              this.viewCharacter();
              this.indexItems();
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    }
  };
</script>
